// Configuração de status e cores
export const statusConfig = {
  Aprovado: { colorScheme: 'green', description: 'Pedido aprovado e pronto para produção' },
  Gravação: { colorScheme: 'blue', description: 'Produto em processo de gravação' },
  Embalagem: { colorScheme: 'purple', description: 'Produto em fase de embalagem' },
  Produção: { colorScheme: 'cyan', description: 'Produto em linha de produção' },
  Expedição: { colorScheme: 'orange', description: 'Produtos em preparação para envio' },
  Separação: { colorScheme: 'teal', description: 'Produtos em separação para expedição' },
  'Controle de Qualidade': { colorScheme: 'pink', description: 'Em verificação de qualidade' },
  Finalizado: { colorScheme: 'green', description: 'Pedido finalizado' },
  Transporte: { colorScheme: 'yellow', description: 'Pedido em transporte' },
  Entrega: { colorScheme: 'red', description: 'Pedido em rota de entrega' },
}

// Array de status para uso em selects
export const statusArray = Object.keys(statusConfig)

// Função para obter a cor com base no status
export function getStatusColor(status) {
  return statusConfig[status]?.colorScheme || 'gray'
}
